import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Header from "../../common/header";
import { useAuth } from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import Layout from "../../common/Layout";
import NavBar from "../../common/NavBar";
import { useAlbum } from "../../hooks/useAlbum";

export default function Admin() {
  const [isSignout, setIsSignout] = useState(false);
  const nav = useNavigate();
  const { user, signout, updateUser, updatePassword, delUser } = useAuth();
  const { resetUserDocs } = useAlbum();

  const onSignout = () => {
    resetUserDocs();
    signout();
  };

  useEffect(() => {
    if (!user.uid) {
      nav("/");
    }
  }, [user.uid]);

  return (
    <Layout>
      <AdminWrap>
        <Header />
        <NavBar name="ADMIN" />
        <div className="Menu">
          <div className="Username">
            <h3>{user?.username}</h3>
            <p className="Red">{!user.emailVerified ? "(인증전)" : ""}</p>
          </div>

          <p>{!user.emailVerified ? "lv. 0" : "lv. " + user.level}</p>
          <p>{user.email}</p>
          <p className="Logout" onClick={onSignout}>
            Logout
          </p>
          <div className="SignoutWrap">
            <p
              className="Signout"
              onClick={() => setIsSignout((prev) => !prev)}
            >
              Signout
            </p>
            {/* {isSignout && <button>확인</button>} */}
          </div>
        </div>
      </AdminWrap>
    </Layout>
  );
}

const AdminWrap = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 120px;
  .Menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 24px;
    gap: 44px;
    .Username {
      display: flex;
      align-items: end;
      margin-left: 48px;
      h3 {
        font-family: nexa-bold;
        font-size: 26px;
      }
      .Red {
        width: 44px;
        margin-left: 6px;
        font-size: 12px;
        font-family: gmarket-sans-medium;
        color: #f94646;
      }
    }

    p {
      position: relative;
    }
    .Logout {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .Signout {
      cursor: pointer;
      color: #f94646;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
